<div class="preview_wrapper">
  <p class="title">Staff Information
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">HR code</p>
        <p class="value">{{staffInformation?.hr_code}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">First Name</p>
        <p class="value">{{staffInformation?.first_name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Last Name</p>
        <p class="value">{{staffInformation?.last_name}}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Email</p>
        <p class="value">{{staffInformation?.email}}</p>
      </div>
    </div>

    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Default Office</p>
        <p class="value">{{staffInformation?.current_tenent?.name}}</p>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Offices</p>
        <p class="value">@for (tenant of staffInformation?.attach_tenents; track tenant) {
          <label>
            {{ tenant.name }}, &nbsp;
          </label>
        }</p>
      </div>
    </div>
  </div>
</div>

<div class="preview_wrapper">
  <p class="title">Staff Detail
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Phone Number</p>
        <p class="value">{{staffDetail?.phone_number}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Staff Department</p>
        @if (staffDetail?.department?.name) {
          <p class="value">
            {{ staffDetail?.department?.name }}
          </p>
        }
        @if (!staffDetail?.department?.name && staffDetail?.department) {
          <p class="value">
            {{ staffDetail.department }}
          </p>
        }
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Roles</p>
        @for (role of staffDetail?.roles; track role) {
          <p class="value">{{role?.name}}</p>
        }
        <!-- <p class="value" *ngIf="staffDetail?.role?.name">
        {{ staffDetail?.role?.name }}
      </p>
      <p class="value" *ngIf="!staffDetail?.role?.name && staffDetail?.role">
        {{ staffDetail?.role }}
      </p> -->
    </div>
  </div>
  <div class="col-md-6">
    <div class="wrap">
      <p class="heading">Start Date</p>
      <p class="value">{{staffDetail?.start_date | date: 'MM/dd/yyyy'}}</p>
    </div>
  </div>
  <div class="col-md-6">
    <div class="wrap">
      <p class="heading">Birthday</p>
      <p class="value">{{staffDetail?.birthday | date: 'MM/dd/yyyy'}}</p>
    </div>
  </div>
  <div class="col-md-6">
    <div class="wrap">
      <p class="heading">Language</p>
      @if (staffDetail?.language?.name) {
        <p class="value">
          {{ staffDetail?.language?.name }}
        </p>
      }
      @if (!staffDetail?.language?.name && staffDetail?.language) {
        <p class="value">
          {{ staffDetail?.language }}
        </p>
      }
    </div>
  </div>
  <div class="col-md-6">
    <div class="wrap">
      <p class="heading">Time Zone</p>
      @if (staffDetail?.time_zone?.zone) {
        <p class="value">
          {{ staffDetail?.time_zone?.zone }}
        </p>
      }
      @if (!staffDetail?.time_zone?.zone && staffDetail?.time_zone) {
        <p class="value">
          {{ staffDetail?.time_zone }}
        </p>
      }
    </div>
  </div>
</div>
</div>


<div class="preview_wrapper">
  <p class="title">Address
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address 1</p>
        <p class="value">{{staffAddress?.staff_address?.address_line_1}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address 2</p>
        <p class="value">{{staffAddress?.staff_address?.address_line_2}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">City</p>
        <p class="value">{{staffAddress?.staff_address?.city}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">State</p>
        <p class="value">{{staffAddress?.staff_address?.state_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Zip Code</p>
        <p class="value">{{staffAddress?.staff_address?.zipcode}}</p>
      </div>
    </div>
  </div>
</div>


<div class="preview_wrapper">
  <p class="title">Salary
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Salary</p>
        <p class="value">{{salary?.salary | currency}}</p>
      </div>
    </div>
  </div>
</div>


<!-- Certification preview - only show in create mode -->
@if (!isEdit && verifyExpiration_dateAndFile_name?.certificates?.expiration_date !== null && hasValidCertifications()) {
  <div class="preview_wrapper">
    <p class="title">Staff Certifications
      <span class="green_circle_tick">
        <img src="../../../../assets/img/white_tick.svg" alt="">
      </span>
    </p>
    @for (certificate of certifications?.certificates; track certificate) {
      <div class="row">
        @if (certificate.is_certified) {
          <div class="col-6" >
            <div class="wrap">
              <p class="heading">Certificate Title</p>
              <p class="value">{{certificate?.name}}</p>
            </div>
          </div>
          <div class="col-6">
            <div class="wrap">
              <p class="heading">Expiration Date</p>
              <p class="value">{{certificate?.expiration_date | date}}</p>
            </div>
          </div>
        }
      </div>
    }
  </div>
}


